import { useAuth } from "../context/AuthContext";

export function usePlan() {
  const { user } = useAuth();
  const plan = user?.plan || "free";
  const role = user?.role || "user";
  const isAdmin = role === "admin";
  const isPro = ["pro", "growth", "enterprise"].includes(plan) || isAdmin;
  const isGrowth = ["growth", "enterprise"].includes(plan) || isAdmin;
  const isEnterprise = plan === "enterprise" || isAdmin;
  return { plan, role, isAdmin, isPro, isGrowth, isEnterprise };
}
